import { FC } from 'react';

export const InternalStatusBadge: FC<{ status: string }> = ({ status }) => {
    const colors: Record<string, string> = {
        active: 'bg-neutral-100 text-neutral-700',
        demo: 'bg-amber-50 text-amber-700',
        inactive: 'bg-neutral-50 text-neutral-500',
    };
    return (
        <span className={`px-1.5 py-0.5 text-[9px] font-medium ${colors[status?.toLowerCase()] || 'bg-neutral-100 text-neutral-600'}`}>
            {status?.toUpperCase()}
        </span>
    );
};
